module.exports = __webpack_public_path__ + "media/mypage/images/pdf_bn-e6290604376c5431a607e9050ea9ea5d.png";